import * as Sentry from '@sentry/react'
import axios from 'axios'

Sentry.init({
  dsn: 'https://9f6ed80362e94d5fb339ac633694fb76@o507863.ingest.us.sentry.io/5599541',
  environment: process.env.REACT_APP_ENV === 'production' ? 'prod' : 'sandbox',
  debug: process.env.REACT_APP_ENV !== 'production',
  maxBreadcrumbs: 50,
})

axios.interceptors.response.use(
  response => response,
  error => {
    // Ignore 401  errors for all endpoints
    if (error.response && error.response.status === 401) {
      return Promise.reject(error);
    }
    // Ignore 404 errors for the user picture endpoint only
    if (
      error.response.status === 404 &&
      error.config.url.includes('secure/user/pic')
    ) {
      return Promise.reject(error);
    }
    if (error.config && error.config.url.includes('/secure/kit')) {
      // Ignore errors for the kit endpoint as they are handled in the Register kit component
      return Promise.reject(error)
    }
    if (error && typeof error === 'object' && error.message?.includes('ref.current')) {
      return Promise.reject(error)
    }
    if (error && typeof error === 'object' && error.message?.includes('Network Error')) {
      return Promise.reject(error)
    }
    Sentry.captureException(error)
    return Promise.reject(error)
  }
)
